module.exports = __webpack_public_path__ + "images/logo-env_production.svg?f26a8075258808b4209a3a2101405b4a";